const nj = require('numjs');
declare var cv: any;


declare module globalThis {
    var cvReady: boolean;
}

const doProjection = (calib_dict: any, wp: any, doUndis=false) => {
    const isFish: boolean = calib_dict['type'] === 'fisheye';
    const k = cv.matFromArray(calib_dict['k'][0].length, 1, cv.CV_64FC1, doUndis ? [0,0,0,0] : [].concat(...calib_dict['k']));
    const R = cv.matFromArray(3, 3, cv.CV_64FC1, [].concat(...calib_dict['R']));
    const K = cv.matFromArray(3, 3, cv.CV_64FC1, [].concat(...calib_dict['K']));
    const t = cv.matFromArray(3, 1, cv.CV_64FC1, [].concat(...calib_dict['t']));

    const input = [].concat(...wp);
    let wparray = cv.matFromArray(wp.length, 1, cv.CV_64FC3, input);

    let ip = new cv.Mat(wp.length, 1, cv.CV_64FC2);
    let Rt = new cv.Mat(3, 3, cv.CV_64FC1);    
    cv.transpose(R, Rt);

    if(isFish && !doUndis) {
        let rvec = new cv.Mat(3, 1, cv.CV_64FC1);  
        cv.Rodrigues(Rt, rvec);
        cv.fisheye_projectPoints(wparray, ip, rvec, t, K, k);        
    } else {
        cv.projectPoints(wparray, Rt, t, K, k, ip);
    }

    let result = nj.zeros([wp.length, 2], 'float64');
    for (var i = 0; i < ip.data64F.length; i+=2) {
        result.set(i/2, 0, ip.data64F[i]);
        result.set(i/2, 1, ip.data64F[i+1]);
    }
    return result;
}

export const projection = (calib_dict: any, wp: any) => {
    if(globalThis.cvReady === false) {
        console.log("OpenCV still initializing, returning projection...");
        return undefined;
    }

    const ip = doProjection(calib_dict, wp, false);
    const ip_undist = doProjection(calib_dict, wp, true);

    const K = nj.float64(calib_dict['K']);
    const principle_point = K.slice([0,2], 2).tolist();
    const ip_undist_array = ip_undist.tolist();
    const radius_squared = ip_undist_array.map((p: any) => Math.pow(p[0]-principle_point[0], 2) + Math.pow(p[1]-principle_point[1], 2));
    
    let valid_radius_squared = 999999999999;
    if(calib_dict['valid_radius'] !== undefined){
        valid_radius_squared = Math.pow(calib_dict['valid_radius'], 2);
    }

    const valid_points_filter = is_in_front_of_camera(calib_dict, wp)
    
    const output = ip.tolist().map((p: any, i: any) => {
        const radiusCheck: boolean = radius_squared[i] < valid_radius_squared;
        const validityCheck: boolean = valid_points_filter[i][0] > 0;
        return radiusCheck && validityCheck ? p : [-1, -1]
    });

    return output;
}


const is_in_front_of_camera = (calib_dict: any, world_coordinates: any) => {
    const cam_position = get_camera_position(calib_dict)

    const normal = get_normal(calib_dict)

    const cam_to_point_vec = world_coordinates.map((p: any) => [p[0]-cam_position[0], p[1]-cam_position[1], p[2]-cam_position[2]]);

    const dot_product = multiply(cam_to_point_vec, normal)

    return dot_product
}

const get_camera_position = (calib_dict: any) => {
    const R = nj.float64(calib_dict['R'])
    const t = nj.float64(calib_dict['t'])

    const camPos = nj.dot(R.multiply(-1), t.T)
    return camPos.tolist()
}

const multiply = (m1: any, m2: any) => {
    var result: Array<Array<number>> = [];
    for (var i = 0; i < m1.length; i++) {
        result[i] = [];
        for (var j = 0; j < m2[0].length; j++) {
            var sum = 0;
            for (var k = 0; k < m1[0].length; k++) {
                sum += m1[i][k] * m2[k][j];
            }
            result[i][j] = sum;
        }
    }
    return result;
}

const get_normal = (calib_dict: any) => {
    const R = nj.float64(calib_dict['R'])

    return multiply(R.tolist(), [[0],[0], [1]])
}